import { useCallback, useMemo } from "react";
import { Button, Paper, Stack, Textarea, TextInput } from "@mantine/core";
import type { LegacyReviewForm } from "../../../utils/legacyReviewForm";

interface Props {
  form: LegacyReviewForm;
  specimenIndex: number;
  slideIndex: number;
}

export default function LegacySlideFields({
  form,
  specimenIndex,
  slideIndex,
}: Props) {
  const path = useMemo(
    () => `specimens.${specimenIndex}.completedSlides.${slideIndex}`,
    [specimenIndex, slideIndex]
  );
  const handleRemove = useCallback(
    () =>
      form.removeListItem(
        `specimens.${specimenIndex}.completedSlides`,
        slideIndex
      ),
    [form, specimenIndex, slideIndex]
  );
  return (
    <Paper withBorder p="sm">
      <Stack gap="sm">
        <TextInput
          label="Completed slide number"
          withAsterisk
          aria-required
          {...form.getInputProps(`${path}.number`)}
        />
        <Textarea
          label="Completed slide evidence"
          withAsterisk
          aria-required
          autosize
          minRows={2}
          {...form.getInputProps(`${path}.evidenceText`)}
        />
        <Button variant="subtle" color="red" onClick={handleRemove}>
          Remove slide
        </Button>
      </Stack>
    </Paper>
  );
}
